import React, {useState, useEffect } from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Cards from '../Cards';
import Footer from '../Footer';
import TeamCards from '../TeamCards'
import ContactUsComponent from '../ContactUsComponent';

function Home () {

    return (
        <>
        <HeroSection />
        
        <div className="statement-wrapper">
            <div className="statement" id="about">
                <h1 className="titles" > About Us </h1>
                <br></br>
                <p>
                We work closely with our clients in bringing software visions to life.
                <br/>
                <br/>
                We specialise in end-to-end mobile application and website development, while also developing broader software engineering solutions to match your use case.
                </p>
            </div>
        </div>
        <div className="team-wrapper" id="team">
            <h1 className="team-title">Our Team</h1>
            <TeamCards />
        </div>
        <Cards />
        <ContactUsComponent />
        <Footer />
        </>
    )
}

export default Home;